import { useEffect } from "react";

const Herbaceuticals = () => {
  useEffect(() => {
    document.title = "Herbaceuticals - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/herbaceuticals.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">
            Herbaceuticals
          </h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">

  {/* <h2>Herbaceuticals</h2> */}
  <h2>Plant Power with Purpose</h2>
  <p><strong>How Natural Oils &amp; Extracts Shape the Herbaceuticals Industry</strong></p>

  <p>At Deww Botanicals, we are deeply rooted in Ayurveda and plant-based healing. As the herbaceuticals industry grows globally—blending traditional herbal wisdom with modern science—our natural oils, extracts, and butters are becoming essential building blocks for high-efficacy formulations that support wellness, immunity, beauty, and vitality.</p>

  {/* <img src="https://via.placeholder.com/700x400?text=Herbaceutical+Industry" alt="Herbaceutical Industry" /> */}

  <h3>What is the Herbaceuticals Industry?</h3>
  <p>Herbaceuticals are plant-based health products that combine herbal actives with scientific formulation to support well-being. They typically fall between nutraceuticals and pharmaceuticals, offering therapeutic benefits without synthetic chemicals.</p>

  <h3>Key Roles of Natural Ingredients in Herbaceuticals</h3>

  <h3>Carrier Oils: Functional Delivery Systems &amp; Nutritional Carriers</h3>
  <p>Cold-pressed carrier oils, such as flaxseed, kalonji (black seed), sesame, and moringa oil, are:</p>
  <ul>
    <li>Rich in essential fatty acids, antioxidants, and vitamins</li>
    <li>Used in oral drops, capsules, massage oils, and topical therapeutic blends</li>
    <li>Effective delivery systems for herbal actives, increasing the bioavailability of fat-soluble compounds</li>
  </ul>

  <p><strong>Ideal for:</strong></p>
  <ul>
    <li>Joint care</li>
    <li>Skin and hair nourishment</li>
    <li>Immune support and inflammation relief</li>
  </ul>

  {/* <img src="https://via.placeholder.com/700x400?text=Carrier+Oils" alt="Carrier Oils" /> */}

  <h3>Essential Oils: Concentrated Botanical Therapies</h3>
  <p>Steam-distilled essential oils such as peppermint, clove, eucalyptus, and lemongrass are utilized in:</p>
  <ul>
    <li>Pain relief balms, decongestants, digestive blends, and stress-relief oils</li>
    <li>Inhalation therapies, vapor rubs, and topical roll-ons</li>
  </ul>

  <p>These oils:</p>
  <ul>
    <li>Are often combined with herbs to amplify their therapeutic effects</li>
    <li>Possess antiseptic, antimicrobial, anti-inflammatory, and aromatic properties, making them indispensable in herbaceutical product lines.</li>
  </ul>

  {/* <img src="https://via.placeholder.com/700x400?text=Essential+Oils" alt="Essential Oils" /> */}

  <h3>Liquid Herbal Extracts: Fast-Acting Phytoactives</h3>
  <p>Deww Botanicals' liquid extracts are concentrated, water- or alcohol-based solutions derived from time-honored herbs like:</p>
  <ul>
    <li>Ashwagandha, Brahmi, Neem, Tulsi, Giloy, Amla, and Turmeric</li>
  </ul>

  <p>They are:</p>
  <ul>
    <li>Highly bioavailable, ideal for tinctures, wellness drops, tonics, and herbal syrups</li>
    <li>Targeted for specific health concerns such as stress, immunity, digestion, detoxification, and skin repair</li>
    <li>Safe for daily use in precise therapeutic doses</li>
  </ul>

  {/* <img src="https://via.placeholder.com/700x400?text=Liquid+Herbal+Extracts" alt="Liquid Herbal Extracts" /> */}

  <h3>Plant Butters: Healing Emollients in Topical Herbaceuticals</h3>
  <p>Plant-based butters like shea, cocoa, and kokum are rich in natural lipids and antioxidants. In the herbaceuticals space, they are used for:</p>
  <ul>
    <li>Topical applications in pain relief creams, ointments, burn balms, and anti-inflammatory rubs</li>
    <li>Supporting transdermal absorption of herbal actives</li>
    <li>Creating protective, soothing bases for sensitive or damaged skin</li>
  </ul>

  {/* <img src="https://via.placeholder.com/700x400?text=Plant+Butters" alt="Plant Butters" /> */}

  <h3>Why Deww Botanicals Ingredients Stand Out in Herbaceuticals</h3>
  <ul>
    <li>Clean, Ayurvedic-grade, and food-safe quality</li>
    <li>Cold-pressed and solvent-free extraction</li>
    <li>Backed by therapeutic heritage and clinical relevance</li>
    <li>Safe for both oral and topical use (as per ingredient)</li>
    <li>Customizable for functional health blends and formulations</li>
  </ul>

  <h3>Bridging Traditional Healing &amp; Modern Wellness</h3>
  <p>At Deww Botanicals, we take pride in supplying the natural oils, butters, and herbal extracts that power a new generation of herbaceutical products—safe, effective, and rooted in nature. Whether used in oral supplements, aromatherapy blends, or therapeutic creams, our botanicals deliver trusted results in natural healing.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Herbaceuticals;
